import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "./Testimonials.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const testimonials = [
  {
    name: "Rahul Sharma",
    role: "Business Owner",
    location: "Hyderabad",
    feedback:
      "The tempo traveller was very comfortable and clean. Our family trip to Warangal was smooth and stress-free. Highly recommended!",
    img: "https://randomuser.me/api/portraits/men/32.jpg",
  },
  {
    name: "Priya Desai",
    role: "Software Engineer",
    location: "Bangalore",
    feedback:
      "Booked a 12-seater AC tempo traveller. The driver was polite, professional, and on time. It made our trip so much better!",
    img: "https://randomuser.me/api/portraits/women/44.jpg",
  },
  {
    name: "Karthik Reddy",
    role: "Entrepreneur",
    location: "Chennai",
    feedback:
      "Affordable rates, excellent condition vehicle, and smooth booking process. Will definitely book again for our next outing.",
    img: "https://randomuser.me/api/portraits/men/65.jpg",
  },
  {
    name: "Ananya Gupta",
    role: "Designer",
    location: "Delhi",
    feedback:
      "Our weekend trip to Srisailam was amazing! The tempo traveller was spacious and very comfortable for our big group.",
    img: "https://randomuser.me/api/portraits/women/68.jpg",
  },
];

// Custom Left Arrow

const PrevArrow = ({ onClick }) => (
  <div className="slick-arrow slick-prev" onClick={onClick}>
    <FaChevronLeft />
  </div>
);

const NextArrow = ({ onClick }) => (
  <div className="slick-arrow slick-next" onClick={onClick}>
    <FaChevronRight />
  </div>
);

const Testimonials = () => {
  const [slidesToShow, setSlidesToShow] = useState(2);

  // Update slidesToShow based on window width
  const handleResize = () => {
    if (window.innerWidth <= 500) {
      setSlidesToShow(1);
    } else if (window.innerWidth <= 768) {
      setSlidesToShow(2);
    } else {
      setSlidesToShow(2);
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
  };

  return (
    <section className="testimonials-section">
      <h2 className="testimonials-title">
        What Our <span> Customers </span> Say
      </h2>
      <p className="testimonials-subtitle">
        Trusted by thousands of happy travellers across India
      </p>

      <Slider {...settings} className="testimonials-slider">
        {testimonials.map((t, index) => (
          <div key={index} className="testimonial-card">
            <div className="testimonial-content">
              <div className="testimonial-text">
                <p className="testimonial-feedback">“{t.feedback}”</p>
                <h3 className="testimonial-name">{t.name}</h3>
                <p className="testimonial-role">
                  {t.role} | {t.location}
                </p>
              </div>
              <div className="testimonial-image">
                <img src={t.img} alt={t.name} />
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
};


export default Testimonials;
